import Typography from "@mui/material/Typography";
import React from "react";
import { TicketErrorHelper } from "../../../Utils/TicketErrorHelper";
import { MenuCardContent, ValidationResult } from "../../../Utils/Interfaces";

export default function CrewMenuContent(title: string, pilotName: string, aircraftName: string, validationResults: ValidationResult[]): MenuCardContent {
    const details = (
        <>
            <Typography textAlign={"center"}>{pilotName}</Typography>
            <Typography textAlign={"center"}>{aircraftName}</Typography>
        </>
    );

    const validationMessages = TicketErrorHelper.getCardErrors(validationResults, title);

    return { details, validationMessages };
}
